export default __webpack_public_path__ + "static/logo-0e2cfbd06a84e6ad60655a388525e9e9.png";